import { Music } from 'lucide-react'
import { Link, useLocation } from 'react-router'

import { cn } from '@/lib/cn'

import { isNavItemActive, NAV_ITEMS } from './navigation'

export function Sidebar() {
  const { pathname } = useLocation()

  return (
    <aside className="sticky top-0 hidden h-dvh w-60 shrink-0 flex-col border-r border-border bg-surface md:flex">
      <div className="flex items-center gap-2.5 px-5 py-5">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent">
          <Music className="h-5 w-5 text-on-accent" aria-hidden="true" />
        </span>
        <span className="text-lg font-semibold tracking-tight text-text">Tunes</span>
      </div>

      <nav aria-label="Primary" className="flex-1 px-3">
        <ul className="flex flex-col gap-0.5">
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                aria-current={isNavItemActive(item, pathname) ? 'page' : undefined}
                className={cn(
                  'flex h-11 items-center gap-3 rounded-lg px-3 text-sm font-medium transition-colors',
                  isNavItemActive(item, pathname)
                    ? 'bg-accent-soft text-accent'
                    : 'text-text-muted hover:bg-surface-hover hover:text-text',
                )}
              >
                <item.icon className="h-5 w-5 shrink-0" aria-hidden="true" />
                <span className="min-w-0 flex-1 truncate">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  )
}
